import React from "react"
import styled from "styled-components"

const Wrapper = styled.div`
  background-color: #fff;
  border: 2px solid ${(props: any) => props.theme.primary};
  padding: 35px 25px;
  text-align: center;
  border-radius: 13px;
  max-width: 630px;
  margin: 0 auto;
  > :first-child {
    color: ${(props: any) => props.theme.secondary};
    font-size: 36px;
    line-height: 44px;
    font-weight: bold;
    margin-bottom: 30px;
  }

  a {
    color: ${(props: any) => props.theme.secondary};
    text-decoration: underline;
  }
`

const Content = styled.div`
  ul {
    list-style-type: number;
    text-align: left;
  }
  li {
    margin: 10px 0px;
  }
`

const Title = styled.div`
  color: ${(props: any) => props.theme.secondary};
  font-size: 36px;
  line-height: 44px;
  font-weight: bold;
  margin-bottom: 30px;
`

const SubTitle = styled(Title)`
  font-size: 26px;
  line-height: 34px;
  margin-bottom: 20px;
`

const ThanksNotApproved = () => (
  <Wrapper>
    <Title>Thank you!</Title>
    <Content>
      <p>
        Almost there! We couldn’t automatically verify your teacher account, but don’t worry, we can approve it for you.
      </p>
      <p>
        Please email <a href="mailto:teachers@nightzookeeper.com">teachers@nightzookeeper.com</a> from your school email address and include your full school name.
      </p>
      <p>
        We’ll review your request and get your free teacher account set up for you as soon as possible.
      </p>
      <SubTitle>While you're waiting...</SubTitle>
      <ul>
        <li>
          <p>Introduce your students to the Night Zoo with this short video!</p>
          <video controls width="100%" src="https://app-cdn.nightzookeeper.com/assets/videos/intro-video.mp4" />
        </li>
        <li>Take a look at our printable teaching resources <a href="/shop/categories/teaching-resources" target='_blank'>here</a></li>
      </ul>
    </Content>
  </Wrapper>
)

export default ThanksNotApproved
